import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

import { BoxWithPointer } from '../StyledCSS'

export const Container = styled(Box)`
  padding-left: ${props => props.theme.global.edgeSize.small};
  padding-bottom: ${props => props.theme.global.edgeSize.medium};
`

export const PartsAndAccessories = styled(BoxWithPointer)`
  margin-right: ${props => props.theme.global.edgeSize.large};
  font-weight: 400;
`

export const GuidesAndArticles = styled(BoxWithPointer)`
  margin-right: ${props => props.theme.global.edgeSize.large};
`

export default {
  PartsAndAccessories,
  GuidesAndArticles,
  Container,
}
